import { ChangeDetectionStrategy, Component, Input, Type } from '@angular/core';
import {
  IconDynamicChatBubbleComponent,
  IconDynamicColors,
  IconDynamicData,
} from '@cigna/omni/shared';
import { combineLatest, Observable } from 'rxjs';
import { ChatBubbleFacade } from '../chat-bubble-state/chat-bubble.facade';
import { ScreenSize } from '@cigna/ui/responsive';
import { FeatureTogglesFacade } from '@cigna/features';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';
import { filter, map, take, tap } from 'rxjs/operators';
import { OmniCommChannelFacade } from '@cigna/omni/comm-channel-feature';
@Component({
  selector: 'cigna-omni-chat-bubble-data',
  templateUrl: './chat-bubble-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatBubbleDataComponent {
  public chatBubbleData$: Observable<
    Record<ScreenSize.XSmall | ScreenSize.Medium, IconDynamicData>
  > = this.chatBubbleFacade.chatBubbleData$;
  public showChatBubble$: Observable<boolean> =
    this.chatBubbleFacade.showChatBubble$;
  public iconColors$: Observable<IconDynamicColors> =
    this.chatBubbleFacade.iconColors$;

  public icon: Type<IconDynamicChatBubbleComponent> =
    IconDynamicChatBubbleComponent;
  public expanderBubble$: Observable<boolean> = this.convFacade.expanderBubble$;
  public isShellOpen$ = this.facade.isShellOpen$.pipe(
    tap((data) => {
      if (data) {
        this.toggleChatIcon(true);
      }
    }),
  );
  public isShellMinimized$ = this.facade.isShellMinimized$;
  public isShellOpenOrMinimized$ = combineLatest([
    this.isShellOpen$,
    this.isShellMinimized$,
  ]).pipe(map(([isOpen, isMinimized]) => isOpen || isMinimized));

  shouldShowNewChatIcon$: Observable<boolean> = this._features.featuresEnabled([
    'showNewChatBubble',
  ]);
  isMaximizeContainer: boolean;
  isExpand: Observable<boolean>;
  isChatBoxMinMax: boolean;
  isChatAvailable: boolean;
  @Input() public shouldEnablePreChatWelcome: boolean;
  @Input() public isUseRightNowChat: boolean;
  @Input() public isLiveClinicianChat: boolean;
  @Input() public isLiveSupportChat: boolean;
  @Input() public isPersonalGuideChat: boolean;
  @Input() public isLiveChatAvailable: boolean;
  @Input() public isConsumerChatEnabled: boolean;

  constructor(
    private chatBubbleFacade: ChatBubbleFacade,
    private _features: FeatureTogglesFacade,
    private facade: OmniChatFacade,
    private convFacade: OmniConversationsFacade,
    private commChannelFacade: OmniCommChannelFacade,
  ) {
    this.convFacade.canAutoOpenConversation$
      .pipe(
        filter((value) => !!value),
        take(1),
      )
      .subscribe(() => {
        this.facade.openDialog();
      });
  }

  public handleEvent(event: any) {
    // eslint-disable-next-line sonarjs/no-small-switch
    switch (event.type) {
      case 'click':
        if (this.shouldEnablePreChatWelcome) {
          this.interact();
        } else {
          this.chatBubbleFacade.chatBubbleClick(event.text);
        }
        break;
      case 'minimize':
        this.facade.toggleChatState();
        break;
      case 'hideOvalChatIcon':
        this.toggleChatIcon(true);
        break;
      case 'showOvalChatIcon':
        this.toggleChatIcon(false);
        break;
      default:
        throw new Error(`Unknown event type: ${event.type}`);
    }
  }

  toggleChatIcon(shouldExpand: boolean) {
    this.convFacade.setExpanderBubble(shouldExpand);
  }

  public interact() {
    if (
      (!this.isUseRightNowChat &&
        !this.isLiveClinicianChat &&
        !this.isLiveSupportChat &&
        !this.isPersonalGuideChat &&
        !this.isConsumerChatEnabled) ||
      !this.isLiveChatAvailable
    ) {
      this.facade.openDialog();
      this.commChannelFacade.nonLiveChatClicked({
        buttonText: 'Chat Closed',
        buttonId: 'chatGuide',
      });
    } else {
      const paramTags = this.isUseRightNowChat
        ? ['advocate', 'member']
        : ['default'];
      this.commChannelFacade.interact(
        {
          buttonText: 'Talk with Us',
          buttonId: 'chatGuide',
        },
        { tags: paramTags },
      );
    }
  }
}
